import { data } from '../../svg/Image/data';
import { makeIcon } from '../makeIcon';

export const Image = makeIcon(data, 'image', 'Image');

export default Image;
